function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7554",
  "data-name": "Grupo 7554",
  transform: "translate(-1760 200.173)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7550",
  "data-name": "Grupo 7550",
  transform: "translate(-413 18)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_38",
  "data-name": "Rect\\xE1ngulo 38",
  transform: "translate(2173 -218.173)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 4,
  height: 4,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_41",
  "data-name": "Rect\\xE1ngulo 41",
  transform: "translate(2173 -212.173)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 4,
  height: 4,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_39",
  "data-name": "Rect\\xE1ngulo 39",
  transform: "translate(2179 -218.173)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 4,
  height: 4,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_40",
  "data-name": "Rect\\xE1ngulo 40",
  transform: "translate(2179 -212.173)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 4,
  height: 4,
  fill: "none"
}))));

function SvgCuadriculaof(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuadriculaof);
export default __webpack_public_path__ + "static/media/cuadriculaof.06a8f0e1.svg";
export { ForwardRef as ReactComponent };